///
/// Comment.jsx
///

const Comment = () => {};

export default Comment;
